<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Hersteller erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.manufacturers.store'))">
                <form-fields
                    :form="form" 
                    :countries="countries"
                    :manufacturers="manufacturers" 
                    />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
            'manufacturers',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    slug: null,
                    short_name: null,
                    aliases_checked: false,
                    aliased_id: null,
                    meta_title: null,
                    meta_description: null,
                    description: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>